import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";

export default async function confirmBulkCloseOut() {
  try {
    const variables = {};

    const query = gql`
      query MyQuery {
        bulkCloseOutParcisionWallet {
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.bulkCloseOutParcisionWallet;
  } catch (error) {
    toast.error("Failed to bulk close out contract");
    sentryWrappedException(error);
    throw error;
  }
}
